import React, { useEffect, useState } from "react";
import TextPage from "./text";
import { getTicker, getFullPageItem } from "../api/core";
import CarouselContentLoader from "../loader/contentLoader";
import NotFound from "../notfound/notfound";
import Ticker from "../Ticker/ticker";

const TextDoc = (props) => {
  const [textVal, setTextVal] = useState([]);
  const [loading, isLoading] = useState(true);
  const [error, SetError] = useState(false);
  const [web, SetWeb] = useState(true);
  const [tickStatus, SetTickStatus] = useState("");
  const [tick, setTick] = useState([]);

  useEffect(() => {
    const FullPageDetail = async (app, id) => {
      /* eslint-disable no-unused-vars */
      const result = await getFullPageItem(app, id, 0, 10).then(
        (result) => {
          getTickerDetail(app, id);
          setTextVal(result.data);
          SetWeb(result.data.devices[0].itemVisibility);
        },
        (error) => {
          SetError(true);
        }
      );
      /* eslint-disable no-unused-vars */
    };
    const getTickerDetail = async (app, id) => {
      /* eslint-disable no-unused-vars */
      const result = await getTicker(app, id).then(
        (result) => {
          setTick(result.data);
          SetTickStatus("200");
        },
        (error) => {}
      );
      /* eslint-disable no-unused-vars */
    };

    FullPageDetail(props.match.params.AppId, props.match.params.videoId);
    isLoading(false);
  }, [props.match.params.videoId, props.match.params.AppId]);

  if (!loading && !error && web && textVal !== null) {
    return (
      <div>
        <TextPage text={textVal}></TextPage>
        {tickStatus === "200" && tick != null ? (
          <Ticker id={"ticker" + 20} tickData={tick}></Ticker>
        ) : (
          ""
        )}
      </div>
    );
  } else {
    if (!web) {
      return (
        <div style={{ minHeight: "500px" }}>
          <NotFound
            code={"Hidden Page"}
            message={"This Page is Hidden in thw Website"}
          ></NotFound>
        </div>
      );
    } else if (loading) {
      return (
        <div style={{ minHeight: "400px" }}>
          <CarouselContentLoader />
        </div>
      );
    } else {
      return <div style={{ minHeight: "400px" }}></div>;
    }
  }
};

export default TextDoc;
